import {Column} from 'react-table'
import {ProvidenceActionsCell} from './ProvidenceActionsCell'
import {ProvidenceCustomHeader} from './ProvidenceCustomHeader'
import {Providence} from '../../core/_models'
import {ProvidenceDescription} from './ProvidenceDescription'
import {ProvidenceNumber} from './ProvidenceNumber'
import {ProvidenceStartDate} from './ProvidenceStartDate'
import {ProvidenceConclusionDate} from './ProvidenceConclusionDate'
import {ProvidenceLimitDate} from './ProvidenceLimitDate'
import {ProvidenceStatus} from './ProvidenceStatus'

const ProvidenceColumns: ReadonlyArray<Column<Providence>> = [
  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <ProvidenceCustomHeader
        tableProps={props}
        title='COMMON.NUMBER'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'providence_number',
    Cell: ({...props}) => <ProvidenceNumber Providence={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ENTERPRISES
  {
    Header: (props) => (
      <ProvidenceCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => <ProvidenceDescription Providence={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  Status ***
  {
    Header: (props) => (
      <ProvidenceCustomHeader
        tableProps={props}
        title='COMMON.STATUS'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'status',
    Cell: ({...props}) => <ProvidenceStatus Providence={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ISSUE DATE ***
  {
    Header: (props) => (
      <ProvidenceCustomHeader
        tableProps={props}
        title='COMMON.START_DATE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'start_date',
    Cell: ({...props}) => <ProvidenceStartDate Providence={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - expiration_date ***
  {
    Header: (props) => (
      <ProvidenceCustomHeader
        tableProps={props}
        title='COMMON.CONCLUSION_DATE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'conclusion_date',
    Cell: ({...props}) => <ProvidenceConclusionDate Providence={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  limit_renovation ***
  {
    Header: (props) => (
      <ProvidenceCustomHeader
        tableProps={props}
        title='COMMON.LIMIT_DATE'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'limit_date',
    Cell: ({...props}) => <ProvidenceLimitDate Providence={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <ProvidenceCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-9 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <ProvidenceActionsCell Providence={props.data[props.row.index]} />,
  },
]

export {ProvidenceColumns}
